module.exports = __webpack_public_path__ + "img/logo-central-pattana.47f506c2.svg";